import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { EmployeurService } from "../../core/service/employeur.service";
import { Employeur } from "../../core/model/employeur";
import { ClassificationEmployeurService } from "../../core/service/classification-employeur.service";
import { ClassificationEmployeur } from "../../core/model/classification-employeur";

@Component({
  selector: "app-edit-employeur",
  templateUrl: "./edit-employeur.component.html",
  styleUrls: ["./edit-employeur.component.scss"],
})
export class EditEmployeurComponent implements OnInit {
  @Input()
  set employeur(value: Employeur) {
    if (value) {
      this._employeur = {
        ...value,
        classificationEmployeur: value.classificationEmployeur
          ? { ...value.classificationEmployeur }
          : new ClassificationEmployeur(),
      };
      this.cdr.detectChanges();
    }
  }
  get employeur(): Employeur {
    return this._employeur;
  }

  private _employeur: Employeur;
  classificationEmployeurs: ClassificationEmployeur[];

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _employeurService: EmployeurService,
    private _classificationEmployeurService: ClassificationEmployeurService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.nullValidator])],
      echeance: [null, Validators.compose([Validators.required])],
      classificationEmployeur: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getClassifications();
  }

  getClassifications() {
    this.loading = true;
    this._classificationEmployeurService.getAll().subscribe(
      (data) => {
        this.classificationEmployeurs = data;
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  save(): void {
    this.pressButton = true;
    const selected = (this.classificationEmployeurs || []).find(
      (c) => c.id === this.employeur.classificationEmployeur.id
    );
    if (selected) {
      this.employeur.classificationEmployeur = { ...selected };
    }

    this._employeurService
      .update(this.employeur)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          // Renvoie l'objet modifié : pas besoin de recharger toute la liste (évite la latence Keycloak)
          this.activeModal.close(this.employeur);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
